import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}niveles_organizacionales`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}niveles_organizacionales/get/list`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}niveles_organizacionales/${id}`);
  return response;
};

const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}niveles_organizacionales`, payload);
  return response;
};

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}niveles_organizacionales`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}niveles_organizacionales/${id}`);
  return response;
};

export { getAll, getList, getById, insert, update, drop };
